import { createDialogStore } from '@/stores/use-dialog'

interface Dashboard {
  bot_id: string
  dashboard_id: string
  name: string
}

interface DashboardDeleteDialogAlertData {
  dashboard: Dashboard
}

export const useDashboardDeleteAlertDialog =
  createDialogStore<DashboardDeleteDialogAlertData>()
